import { Paper } from "@mui/material";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DATA_GRID_SLOTS } from "../../BasicComponents/DataGridSlots";
import { logEvent, logException } from "../../helper/AppInsightsHelper";
import { useGetFavoritePartnersByLoginQuery } from "../../slices/ExplorePartners.slice";

export default function FavoritePartnersGridComponent() {
  const [rows, setRows] = useState<GridRowsProp>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { data, error } = useGetFavoritePartnersByLoginQuery();

  const columns: GridColDef[] = [
    {
      headerName: "Partner One Id",
      field: "partnerOneId",
      width: 300,
      sortable: false,
      flex: 1,
      renderCell: (params) => (
        <a
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 12,
            cursor: "pointer"
          }}
          onClick={() => {
            navigate(`/partners?partnerOneId=${encodeURIComponent(params.row.partnerOneId ?? "")}&mpnId=AllUp`);
          }}
        >
          {params.row.partnerOneId}
        </a>
      )
    },
    {
      headerName: "Partner One Name",
      field: "partnerOneName",
      width: 300,
      sortable: false
    },
    {
      headerName: "Favorite Status",
      field: "isFavorite",
      width: 300,
      sortable: false,
      renderCell: (params) => <span>{params.row.isFavorite ? "⭐ Favorite" : "Not Favorite"}</span>
    }
  ];

  useEffect(() => {
    if (data) {
      setRows(data);
      setLoading(false);
      logEvent("getFavoritePartners API call success", "My Favorites", "FavoritePartnersGridComponent");
    } else if (error) {
      setLoading(false);
      logException("My Favorites", "FavoritePartnersGridComponent", "getFavoritePartners", error);
    } else {
      setLoading(true);
    }
  }, [data, error]);

  return (
    <Paper>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.partnerOneId ?? crypto.randomUUID()}
        loading={loading}
        keepNonExistentRowsSelected
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableRowSelectionOnClick
        disableColumnSelector
        slots={{
          loadingOverlay: DATA_GRID_SLOTS.loadingOverlay,
          noRowsOverlay: DATA_GRID_SLOTS.noFavoritePartnersOverlay(!!error)
        }}
      />
    </Paper>
  );
}
